import React, { useState } from "react";
import { useSelector } from "react-redux";
import { QRCodeCanvas } from "qrcode.react";
import useApi from "../../../CustomHooks/useApi";

const Qrcodemerchant = () => {
  const [showQR, setShowQR] = useState(false);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [qrLink, setQrLink] = useState("");

  const mid = useSelector(
    (s) => s.auth.employeeDetails?.username
  );

  const { callApi: generateQR } = useApi(
    "/vegah/dynamic/qr/create",
    "POST"
  );

  const handleGenerateQR = async () => {
    if (!amount || Number(amount) <= 0) return;

    try {
      setLoading(true);

      const payload = {
        username: mid,
        amount: Number(amount).toFixed(2),
      };

      const res = await generateQR(payload);

      console.log("QR Response:", res);

      // paymentLink nikalo
      const paymentLink =
        res?.paymentLink ||
        res?.data?.paymentLink ||
        "";

      setQrLink(paymentLink);
      setShowQR(true);

    } catch (error) {
      console.error("QR Generate Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 m-2 flex flex-col items-center">

      {/* Heading */}
      <h1 className="text-3xl font-bold text-gray-800">
        QR CODE
      </h1>

      {/* Info Box */}
      <div className="mt-4 bg-green-100 text-green-700 p-3 text-center rounded-xl w-full max-w-md">
        Scan a QR code for fast, secure payments 🚀
      </div>

      {/* Amount Input */}
      <div className="mt-6 w-full max-w-md">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Enter Amount
        </label>

        <div className="flex items-center border rounded-xl overflow-hidden shadow-sm bg-white">
          <span className="px-4 bg-gray-100 text-gray-600 font-semibold">
            ₹
          </span>

          <input
            type="text"
            inputMode="numeric"
            placeholder="Enter amount"
            value={amount}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");

              setAmount(value);
              setShowQR(false);
            }}
            className="w-full px-4 py-3 outline-none"
          />
        </div>
      </div>

      {/* QR Section */}
      <div className="mt-10 relative flex justify-center items-center bg-white p-6 rounded-2xl shadow-lg min-h-[320px] min-w-[320px]">

        {showQR && qrLink ? (
          <QRCodeCanvas
            value={qrLink}
            size={280}
            level="H"
            includeMargin={true}
          />
        ) : (
          <div className="w-72 h-72 flex items-center justify-center bg-gray-100 rounded-xl blur-sm opacity-50">
            QR Preview
          </div>
        )}

        {!showQR && (
          <div className="absolute inset-0 flex items-center justify-center">
            <button
              onClick={handleGenerateQR}
              disabled={!amount || loading}
              className={`px-6 py-3 rounded-xl shadow-lg font-medium transition text-white ${
                amount
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-gray-400 cursor-not-allowed"
              }`}
            >
              {loading ? "Generating..." : "Generate QR"}
            </button>
          </div>
        )}
      </div>

      {/* Amount Display */}
      {showQR && (
        <div className="mt-5 text-lg font-semibold text-green-700">
          Payment Amount: ₹{amount}
        </div>
      )}
    </div>
  );
};

export default Qrcodemerchant;